export const isAdaptableCellChangedAlert = (alert) => {
    return alert.alertType === 'cellChanged';
};
export const isAdaptableRowChangedAlert = (alert) => {
    return alert.alertType === 'rowChanged';
};
